/* elestablo 2026 · Línea (colección) y búsqueda — agente C; ajustes móviles del frente B (28-sep-2026).
   Mejora progresiva: sin este archivo todo funciona con formularios GET y enlaces normales. */
(function () {
  'use strict';

  function dialogoDe(boton) {
    return document.getElementById(boton.getAttribute('aria-controls'));
  }

  // Abrir / cerrar la hoja de filtros (<dialog> nativo: foco atrapado y Esc de serie).
  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-ee-abrir-filtros]');
    if (abrir) {
      var d = dialogoDe(abrir);
      if (d && typeof d.showModal === 'function') {
        e.preventDefault();
        d.showModal();
        abrir.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    var cerrar = e.target.closest('[data-ee-cerrar-filtros]');
    if (cerrar) {
      var dlg = cerrar.closest('dialog');
      if (dlg) dlg.close();
    }
  });

  document.querySelectorAll('dialog.ee-filtros').forEach(function (d) {
    // Tocar el fondo oscuro cierra la hoja.
    d.addEventListener('click', function (e) {
      if (e.target === d) d.close();
    });
    d.addEventListener('close', function () {
      document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    });
  });

  // Parámetros de un formulario del listado: sin vacíos (precio sin llenar) ni el orden por defecto.
  function parametros(f) {
    var params = new URLSearchParams();
    var defecto = f.getAttribute('data-ee-orden-defecto');
    new FormData(f).forEach(function (valor, nombre) {
      if (String(valor).trim() === '') return;
      if (nombre === 'sort_by' && defecto && valor === defecto) return;
      params.append(nombre, valor);
    });
    return params;
  }

  function unir(destino, qs) {
    return destino + (qs ? (destino.indexOf('?') > -1 ? '&' : '?') + qs : '');
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-ee-form-listado]')) return;
    e.preventDefault();
    window.location.href = unir(f.getAttribute('action') || window.location.pathname, parametros(f).toString());
  });

  // Ordenar (tableta y computador): aplicar apenas se elige una opción.
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-ee-orden]');
    if (!s || !s.form) return;
    if (typeof s.form.requestSubmit === 'function') s.form.requestSubmit();
    else s.form.submit();
  });

  // "Ver N productos": al cambiar un filtro se pide la sección con esos filtros y se lee el total.
  document.querySelectorAll('form[data-ee-conteo]').forEach(function (f) {
    var etiqueta = f.querySelector('[data-ee-ver]');
    var seccion = f.getAttribute('data-ee-seccion');
    if (!etiqueta || !seccion || !window.fetch || !window.DOMParser) return;
    var muchos = f.getAttribute('data-ee-sustantivo') || 'productos';
    var uno = f.getAttribute('data-ee-sustantivo-uno') || 'producto';
    var espera = null;
    var control = null;
    function contar() {
      var params = parametros(f);
      params.delete('sort_by');
      params.set('section_id', seccion);
      if (control) control.abort();
      control = window.AbortController ? new AbortController() : null;
      etiqueta.textContent = 'Contando…';
      fetch(unir(f.getAttribute('action') || window.location.pathname, params.toString()), {
        credentials: 'same-origin',
        signal: control ? control.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-ee-total]');
          var n = el ? parseInt(el.getAttribute('data-ee-total'), 10) : NaN;
          if (isNaN(n)) throw new Error('sin total');
          etiqueta.textContent = n === 0 ? 'Sin ' + muchos : n === 1 ? 'Ver 1 ' + uno : 'Ver ' + n.toLocaleString('es-CO') + ' ' + muchos;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          etiqueta.textContent = 'Ver ' + muchos;
        });
    }
    function programar(e) {
      if (e.target && e.target.name === 'sort_by') return;
      clearTimeout(espera);
      espera = setTimeout(contar, e.type === 'input' ? 600 : 250);
    }
    f.addEventListener('change', programar);
    f.addEventListener('input', function (e) {
      if (e.target && e.target.type === 'number') programar(e);
    });
  });

  // "Cargar más productos": trae la página siguiente y agrega sus tarjetas a la rejilla.
  // Los agotados (li[data-ee-agotado]) quedan siempre al final: la tanda nueva entra antes del primer agotado.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ee-cargar-mas]');
    if (!a || !window.fetch || !window.DOMParser) return;
    var rejilla = document.getElementById(a.getAttribute('data-rejilla'));
    var pie = document.getElementById(a.getAttribute('data-pie'));
    if (!rejilla || !pie) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true');
    var etiqueta = a.querySelector('[data-ee-etiqueta]');
    var textoAntes = etiqueta ? etiqueta.textContent : '';
    if (etiqueta) etiqueta.textContent = 'Cargando…';

    fetch(a.href, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nueva = doc.getElementById(rejilla.id);
        var nuevoPie = doc.getElementById(pie.id);
        if (!nueva) throw new Error('sin rejilla');
        var items = Array.prototype.slice.call(nueva.children);
        var primerAgotado = rejilla.querySelector(':scope > li[data-ee-agotado]');
        var primeroNuevo = null;
        items.forEach(function (li) {
          var copia = document.importNode(li, true);
          if (copia.hasAttribute('data-ee-agotado') || !primerAgotado) rejilla.appendChild(copia);
          else rejilla.insertBefore(copia, primerAgotado);
          if (!primeroNuevo && !copia.hasAttribute('data-ee-agotado')) primeroNuevo = copia;
        });
        if (!primeroNuevo && items.length) primeroNuevo = rejilla.lastElementChild;
        if (nuevoPie) {
          var piePegado = document.importNode(nuevoPie, true);
          piePegado.querySelectorAll('[data-ee-anterior]').forEach(function (x) { x.remove(); });
          pie.replaceWith(piePegado);
        } else {
          pie.remove();
        }
        // Llevar el foco al primer producto nuevo (teclado y lectores de pantalla).
        var enlace = primeroNuevo && primeroNuevo.querySelector('a[href]');
        if (enlace) enlace.focus({ preventScroll: true });
      })
      .catch(function () {
        if (etiqueta) etiqueta.textContent = textoAntes;
        window.location.href = a.href;
      });
  });

  // Subcategorías: el chip activo queda a la vista.
  document.querySelectorAll('[data-ee-subcats]').forEach(function (nav) {
    var activo = nav.querySelector('[aria-current]');
    if (!activo || nav.scrollWidth <= nav.clientWidth) return;
    var li = activo.closest('li') || activo;
    if (li.offsetLeft + li.offsetWidth > nav.clientWidth - 24) nav.scrollLeft = Math.max(0, li.offsetLeft - 16);
  });

  // Descripción corta en celular: si el único párrafo cabe en 2 líneas, sobra el "Ver más".
  document.querySelectorAll('[data-ee-desc]').forEach(function (d) {
    var solo = d.querySelector('.ee-mb-desc--solo');
    var primero = d.querySelector('.ee-mb-desc__primero');
    if (!solo || !primero) return;
    if (primero.scrollHeight <= primero.clientHeight + 2) solo.classList.add('ee-mb-desc--sobra');
  });

  // Agregar desde la tarjeta: el botón confirma "Agregado" 1,6 s (y vibra corto donde se pueda).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      if (!evento || evento.source !== 'product-form' || !evento.productVariantId) return;
      var id = String(evento.productVariantId);
      document.querySelectorAll('.ee-mb-tarjeta input[name="id"]').forEach(function (inp) {
        if (inp.value !== id) return;
        var btn = inp.form && inp.form.querySelector('.ee-mb-btn--agregar');
        var txt = btn && btn.querySelector('.ee-mb-btn__txt');
        if (!btn || !txt) return;
        btn.classList.add('ee-mb-agregado');
        txt.textContent = 'Agregado';
        setTimeout(function () {
          btn.classList.remove('ee-mb-agregado');
          txt.textContent = 'Agregar';
        }, 1600);
      });
      if (navigator.vibrate) {
        try { navigator.vibrate(15); } catch (err) { /* sin vibración */ }
      }
    });
  }
})();
